/**
 * PermissionA5 统一配置出口。
 * 各文件默认导出「rootPath 之下的子树」，在此挂到顶层 key 后供 PermissionA5 引用。
 */
import dispatchPageTree from './dispatchPage'
import systemControlTree from './systemControl'
import surveillancePageTree from './surveillancePage'
import ysDeviceListTree from './ysDeviceList'
import tuinaPageTree from './tuinaPage'

const permissionConfig = {
  dispatchPage: dispatchPageTree,
  systemControl: systemControlTree,
  surveillancePage: surveillancePageTree,
  ysDeviceList: ysDeviceListTree,
  tuinaPage: tuinaPageTree
}

export default permissionConfig
